var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlertCaution = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.822 31a1.5 1.5 0 0 1-1.333-2.19L14.668 1.4a1.5 1.5 0 0 1 2.664 0l14.179 27.41A1.5 1.5 0 0 1 30.178 31zM16 3.177 2.643 29h26.714zM16 11a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1m0 15.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
})));
export default SvgAlertCaution;